export class KeyUnlockDeclinedError extends Error {
    constructor(label) {
        super('unlock declined');
        this.label = label;
        this.name = 'KeyUnlockDeclinedError';
    }
}
export function canPromptForKeys(context) {
    var _a;
    return ((_a = context === null || context === void 0 ? void 0 : context.canPrompt) === null || _a === void 0 ? void 0 : _a.call(context)) === true;
}
